import React from 'react';
import { Badge } from 'react-bootstrap';

import { ChipBackgroundColor, ChipLabelColor } from './types';
import './chip.css';

interface ChipProps {
  icon: React.ReactNode;
  labelText: string;
  labelColor?: ChipLabelColor;
  backgroundColor?: ChipBackgroundColor;
  pill?: boolean;
}
const Chip = ({
  icon,
  labelText,
  labelColor = ChipLabelColor.RED,
  backgroundColor = ChipBackgroundColor.RED,
  pill,
}: ChipProps) => {
  const pillShape = pill ? 'chip-shape' : '';
  const colorForBackground = React.useMemo(
    () => `bg-${backgroundColor}`,
    [backgroundColor],
  );
  const colorForLabel = React.useMemo(() => `text-${labelColor}`, [labelColor]);
  return (
    <Badge
      className={`chip-container ${pillShape} ${colorForBackground} ${colorForLabel}`}
      pill={pill}
    >
      {icon}
      <span>{labelText}</span>
    </Badge>
  );
};

export default Chip;
